<template>
    <div v-if="code || string ">
        <button-secondary @click="open">
            Anzeigen
       </button-secondary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>QR-Code</template>

                <loading v-show="loading"></loading>

                <p class="font-bold flex justify-center"> {{ name }}</p>

                <div class="flex justify-center" v-show="!loading">
                    <img :src="code" alt="QR-Code"/>
                </div>

                <p class="flex justify-center mb-2"> {{ origin }}/#/desks/check_in/{{ uuid }}  </p>

                <warning v-show="!loading">
                    Über den angezeigten QR-Code lässt sich das OfficeEfficient Check-In Feature nutzen.  
                </warning>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "./Modal.vue";
import Warning from "./UI/Warning.vue";
import ButtonSecondary from "./UI/ButtonSecondary.vue";
import Loading from "./UI/Loading.vue";

export default {
    name: "QRCodeView",
    components: {
        Loading,
        ButtonSecondary,
        Warning,
        Modal,
    },

    props: {
        code: {
            default: null,
        },
        name: {
            default: null,
        },
        uuid: {
            default: null,
        },

    },

    data: () => ({
        showModal: false,
        loading: false,
        image: null,
        origin: window.location.origin,
    }),

    methods: {
        open() {
            this.showModal = true;
        }
    }

}
</script>

<style scoped>

</style>
